import React from 'react';
import './terms.css';

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service</h1>
      <p>Welcome to our service. By accessing and using this website, you agree to be bound by the following terms and conditions. If you do not agree with any part of these terms, you must discontinue using our website.</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By using our website, you agree to comply with and be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our services.</p>
      </section>

      <section>
        <h2>2. Changes to Terms</h2>
        <p>We reserve the right to update, modify, or change these terms at any time without prior notice. You are responsible for reviewing these terms periodically to stay informed of any changes. Your continued use of the website after any changes constitutes your acceptance of the modified terms.</p>
      </section>

      <section>
        <h2>3. User Responsibilities</h2>
        <p>As a user of this website, you agree to:</p>
        <ul>
          <li>Provide accurate and up-to-date information when registering or interacting with the website.</li>
          <li>Not engage in any activity that could harm, disrupt, or damage the functioning of the website or the experience of other users.</li>
          <li>Not attempt to gain unauthorized access to the website or its related systems.</li>
          <li>Follow all applicable laws and regulations while using the website.</li>
        </ul>
      </section>

      <section>
        <h2>4. Account Registration</h2>
        <p>In order to access certain features of the website, you may need to create an account. When registering, you agree to provide accurate information and maintain the confidentiality of your login credentials. You are fully responsible for all activities under your account.</p>
      </section>

      <section>
        <h2>5. Privacy and Data Protection</h2>
        <p>Your privacy is important to us. We collect and use personal information as described in our Privacy Policy. By using this website, you consent to the collection and use of your data in accordance with our Privacy Policy.</p>
      </section>

      <section>
        <h2>6. Prohibited Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Violate any applicable local, state, national, or international law or regulation.</li>
          <li>Engage in activities that infringe upon the intellectual property rights of others.</li>
          <li>Transmit harmful, defamatory, offensive, or illegal content through the website.</li>
          <li>Interfere with the operation of the website or disrupt the user experience.</li>
        </ul>
      </section>

      <section>
        <h2>7. Termination of Access</h2>
        <p>We reserve the right to suspend or terminate your access to the website at any time, without notice, for any reason, including but not limited to violation of these terms or engagement in prohibited activities.</p>
      </section>

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>Our website is provided "as is" without any warranties of any kind, either express or implied. We do not guarantee that the website will be available at all times, free of errors, or secure. To the fullest extent permitted by law, we are not liable for any damages arising out of the use or inability to use the website.</p>
      </section>

      <section>
        <h2>9. Indemnification</h2>
        <p>You agree to indemnify and hold harmless the website owners, employees, affiliates, and partners from any claims, damages, liabilities, and expenses (including legal fees) arising from your use of the website or violation of these terms.</p>
      </section>

      <section>
        <h2>10. Third-Party Links</h2>
        <p>Our website may contain links to third-party websites. These links are provided for convenience and informational purposes only. We do not endorse or control the content of third-party websites, and you access them at your own risk.</p>
      </section>

      <section>
        <h2>11. Governing Law</h2>
        <p>These Terms of Service will be governed by and construed in accordance with the laws of the jurisdiction in which our company is located. Any disputes arising from these terms will be resolved in the competent courts of that jurisdiction.</p>
      </section>

      <section>
        <h2>12. Dispute Resolution</h2>
        <p>In the event of a dispute, both parties agree to attempt to resolve the issue through mediation or alternative dispute resolution methods before pursuing formal legal action.</p>
      </section>

      <section>
        <h2>13. Severability</h2>
        <p>If any part of these Terms of Service is found to be invalid or unenforceable by a court of law, the remaining provisions will continue to be in full effect.</p>
      </section>

      <section>
        <h2>14. Contact Information</h2>
        <p>If you have any questions about these Terms of Service, please contact us at:</p>
        <p><strong>Email:</strong> info@interncourse.online</p>
       
      </section>
    </div>
  );
};

export default Terms;
